import { buildSlotGridFromConfig } from "./timetableTimeSlots";

/** Default 09:00–22:00 grid with lunch — same as TimetableView when API has no schedule. Supports night schedules. */
export function getDefaultSchoolDayScheduleRows() {
  const { slotsPerDayForUi } = buildSlotGridFromConfig({
    dayStart: "09:00",
    dayEnd: "22:00",
    slotDurationMinutes: 60,
    breaks: [{ start: "12:00", end: "13:00", label: "Lunch" }],
  });
  return slotsPerDayForUi;
}

function defaultScheduleRows() {
  return getDefaultSchoolDayScheduleRows();
}

/**
 * Unwrap axios response + API envelope { data: { id, slots, slotsPerDay, ... } }.
 * React Query previously stored the raw AxiosResponse; this yields the timetable row reliably.
 */
export function unwrapTimetableRecordFromQueryResult(raw) {
  if (raw == null) return undefined;
  let x = raw;
  if (typeof x?.status === "number" && x.data !== undefined && x.config != null) {
    x = x.data;
  }
  for (let depth = 0; depth < 6 && x && typeof x === "object"; depth += 1) {
    if (x.id != null || Array.isArray(x.slots)) return x;
    if (x.data != null && typeof x.data === "object") {
      x = x.data;
      continue;
    }
    break;
  }
  return x;
}

function parseGenerationStats(raw) {
  if (raw == null) return null;
  if (typeof raw === "string") {
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }
  return raw;
}

/**
 * Resolve per-day schedule rows (school hours + breaks) from GET timetable payload.
 * Uses top-level slotsPerDay, generationStats.scheduleTemplate.slotsPerDay, or
 * rebuilds from scheduleTemplate.dayStart/dayEnd/breaks/slotDurationMinutes when the array was not stored.
 */
export function getScheduleSlotsPerDayFromDetail(detail) {
  if (!detail || typeof detail !== "object") return null;

  if (Array.isArray(detail.slotsPerDay) && detail.slotsPerDay.length > 0) {
    return detail.slotsPerDay;
  }

  const topSt = detail.scheduleTemplate;
  if (topSt && typeof topSt === "object") {
    if (Array.isArray(topSt.slotsPerDay) && topSt.slotsPerDay.length > 0) {
      return topSt.slotsPerDay;
    }
    if (topSt.dayStart && topSt.dayEnd) {
      const { slotsPerDayForUi } = buildSlotGridFromConfig({
        dayStart: topSt.dayStart,
        dayEnd: topSt.dayEnd,
        slotDurationMinutes: topSt.slotDurationMinutes,
        breaks: topSt.breaks,
      });
      return slotsPerDayForUi;
    }
  }

  const parsed = parseGenerationStats(detail.generationStats);
  const st = parsed?.scheduleTemplate;
  if (!st || typeof st !== "object") {
    if (detail.id != null || Array.isArray(detail.slots)) {
      return defaultScheduleRows();
    }
    return null;
  }

  if (Array.isArray(st.slotsPerDay) && st.slotsPerDay.length > 0) {
    return st.slotsPerDay;
  }

  if (st.dayStart && st.dayEnd) {
    const { slotsPerDayForUi } = buildSlotGridFromConfig({
      dayStart: st.dayStart,
      dayEnd: st.dayEnd,
      slotDurationMinutes: st.slotDurationMinutes,
      breaks: st.breaks,
    });
    return slotsPerDayForUi;
  }

  return defaultScheduleRows();
}

/** @deprecated Use unwrapTimetableRecordFromQueryResult — kept for any stray imports */
export function getTimetableRecordFromQueryData(timetableData) {
  return unwrapTimetableRecordFromQueryResult(timetableData);
}
